// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { useMemo } from "react";

interface Props {
    cart?: Cart;
}

const xUseSortCartLines = ({ cart }: Props) => {
    const getCartLinePriority = (cartLine: CartLineModel) =>
        cartLine.isRestricted ||
        !cartLine.isActive ||
        cartLine.cantBuy ||
        cartLine.quoteRequired ||
        cartLine.pricing?.unitNetPrice === 0
            ? 0
            : 1;

    const sortedCartLines = useMemo(
        () => [...(cart?.cartLines ?? [])].sort((a, b) => getCartLinePriority(a) - getCartLinePriority(b)),
        [cart?.cartLines],
    );

    return sortedCartLines;
};

export default xUseSortCartLines;
